import { moduleNames } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import unitMasterService from "@services/master-data/unitMasterService"
import { action, makeAutoObservable, observable } from "mobx"

class UnitMasterStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listFromtower!: any

  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    this.isLoading = true
    if (!body.id) {
      const result = await unitMasterService
        .create(body)
        .catch(() => (this.isLoading = false))
      this.isLoading = false

      this.detailData = result

      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService.upload(moduleNames.unit, uniqueId, fileUpload)
          }
        })
      }
    } else {
      const result = await unitMasterService
        .update(body)
        .catch(() => (this.isLoading = false))

      this.detailData = result
      this.isLoading = false
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService.upload(moduleNames.unit, uniqueId, fileUpload)
          }
        })
      }
    }
  }

  @action
  async newMasterUnit() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await unitMasterService.active(id, isActive)
  }

  @action
  async get(id: number) {
    const result = await unitMasterService.get(id)
    this.detailData = result
  }

  @action
  async emptyTable() {
    this.tableData = { items: [], totalCount: 0 }
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await unitMasterService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getListFromTower(params: any) {
    this.isLoading = true
    const result = await unitMasterService
      .getListFromTower(params)
      .finally(() => (this.isLoading = false))
    this.listFromtower = result
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await unitMasterService
        .import(file)
        .finally(() => (this.isLoading = false))

      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default UnitMasterStore
